/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_LabelsInputs */

const en_cmd_labels = /** @type {(inputs: Cmd_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change fields and labels`)
};

const de_cmd_labels = /** @type {(inputs: Cmd_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felder und Labels ändern`)
};

/**
* | output |
* | --- |
* | "Change fields and labels" |
*
* @param {Cmd_LabelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_labels = /** @type {((inputs?: Cmd_LabelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_LabelsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_labels(inputs)
	return en_cmd_labels(inputs)
});